module.exports = __webpack_public_path__ + "img/DW365-186.0f8d1ea3.jpg";